var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-signup-eu.j2"] = require( "loyalty-signup-eu.j2" );
dependencies["loyalty-signup-eu-update-info.j2"] = require( "loyalty-signup-eu-update-info.j2" );
dependencies["house-home-signup.j2"] = require( "house-home-signup.j2" );
dependencies["help-request-catalog.j2"] = require( "help-request-catalog.j2" );
dependencies["house-home-signup-eu.j2"] = require( "house-home-signup-eu.j2" );
dependencies["personal-stylist-form.j2"] = require( "personal-stylist-form.j2" );
dependencies["generic-email-service.j2"] = require( "generic-email-service.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/help-generic-email-service-template.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference")) {
output += "\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "loyalty-signup-eu.j2") {
output += "\n        ";
env.getTemplate("loyalty-signup-eu.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "loyalty-signup-eu-update-info.j2") {
output += "\n        ";
env.getTemplate("loyalty-signup-eu-update-info.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "house-home-signup.j2") {
output += "\n        ";
env.getTemplate("house-home-signup.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "help-request-catalog.j2") {
output += "\n        ";
env.getTemplate("help-request-catalog.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "house-home-signup-eu.j2") {
output += "\n        ";
env.getTemplate("house-home-signup-eu.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n    ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"templateReference") == "personal-stylist-form.j2") {
output += "\n        ";
env.getTemplate("personal-stylist-form.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n    ";
})});
}
else {
output += "\n        ";
env.getTemplate("generic-email-service.j2", false, "core/templates/help-generic-email-service-template.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n    ";
})});
}
;
}
;
}
;
}
;
}
;
}
output += "\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/help-generic-email-service-template.j2"] , dependencies)